/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { StyleSheet } from 'aphrodite';
import { isEmptyValue, Checkbox } from '@blend/enterprise-components';

import { WrappedInput } from 'id-components/WrappedInput';
import { FinalFormInputConfig } from 'id-types/helpers';
import {
  passwordInputConfigWithValidation,
  confirmPasswordInputConfig as commonConfirmPasswordConfig,
} from 'id-constants/commonInputs';

import { ComplianceInputLabel } from './ComplianceInputLabel';

const styles = StyleSheet.create({
  fieldWrapperSm: {
    ':not(:last-child)': {
      marginBottom: 8,
    },
  },
});

export const passwordInputConfig = passwordInputConfigWithValidation;

export const confirmPasswordInputConfig = commonConfirmPasswordConfig;

// the `checked` prop is managed internally by react-final-form
export const complianceInput: FinalFormInputConfig<Omit<Checkbox.Props, 'checked'>, string> = {
  component: WrappedInput,
  containerStyles: [styles.fieldWrapperSm],
  customComponentProps: {},
  displayAdditionalMessagingInContainer: false,
  inputComponent: Checkbox,
  label: <ComplianceInputLabel />,
  labelPosition: 'right',
  labelSize: 'sm',
  name: 'acceptedCompliance',
  type: 'checkbox',
  validate: isEmptyValue('You must agree to the Terms of Use and Privacy policy before proceeding'),
};
